document.addEventListener('ShoptetDOMPageContentLoaded', function () {
    customSorting();

});
document.addEventListener('ShoptetPageSortingChanged', function () {
    customSorting();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
    customSorting();
});
$(document).ready(function () {
    customSorting();
});



function customSorting() {
    $('.advanced-parameter-inner.show-tooltip').removeClass('show-tooltip').removeAttr('data-original-title');
 /*  if( $('.category__secondDescription').length) {
        $('.category__secondDescription').prepend(`<h2>${$('h1').text()}</h2>`)
   }
    */



    if ($('.pagination__link--prev').length) {
        $('.pagination__link--prev').closest('li').addClass('pprev');
    }
    if ($('.pagination__link--next').length) {
        $('.pagination__link--next').closest('li').addClass('pnext');
    }

    if (!$('#category-header .customSorting').length) {
        $('#category-header').append('<span class="customSorting">Seřadit dle</span>');
    }


    $('.listSorting__controls li').each(function () {
        if ($(this).find('button').hasClass('listSorting__control--current')) {
            $('#category-header .customSorting').text($(this).find('button').text());
        }
    });

    $('html').on('click', '.customSorting', function () {
        $(this).closest('#category-header').toggleClass('showSorting');
        $(this).closest('#category-header').find('.listSorting').toggleClass('showSorting');
        $(this).toggleClass('showSorting');
    });

}

